// config.js
export const FRONTEND_ID = "SuperSub"; // Change this per deployment (e.g., "Dallas")
